import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Coupon from '../views/Coupon.vue'
import ErrorGeneric from '../views/ErrorGeneric.vue'
import CouponActive from '../views/CouponActive.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ChangePassword from '../views/ChangePassword.vue'
import ResetPasswordDone from '../views/ResetPasswordDone.vue'
import Profile from '../views/Profile.vue'
import Payment from '../views/Payment.vue'
import PaymentOffer from '../views/PaymentOffer.vue'
import PaymentSuccess from '../views/PaymentSuccess.vue'
import CancelPlan from '../views/CancelPlan.vue'
import Checkout from '../views/Checkout.vue'
import CheckoutCompleted from '../views/CheckoutCompleted.vue'
import Paddle from '../views/Paddle.vue'
import PaddleCheckout from '../views/PaddleCheckout.vue'
import * as firebase from 'firebase/app'
import store from '../store'
import { i18n } from '../assets/i18n/i18n'
import { localeChanged } from 'vee-validate'
import { trackEvent } from '../plugins/analyticsTracker'
const _ = require('lodash')

import 'firebase/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => {
      if (store.getters.isUserLogged) {
        return import('../views/Profile.vue')
      } else {
        return import('../views/Register.vue')
      }
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: ForgotPassword
  },
  {
    path: '/set-password',
    name: 'SetPassword',
    component: ChangePassword
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { requiresAuth: true }
  },
  {
    path: '/coupon',
    name: 'Coupon',
    component: Coupon,
    meta: { requiresAuth: true }
  },
  {
    path: '/error',
    name: 'Error',
    component: ErrorGeneric,
    meta: { requiresAuth: false }
  },
  {
    path: '/coupon-active',
    name: 'CouponActive',
    component: CouponActive,
    meta: { requiresAuth: true }
  },
  {
    path: '/reset-password-done',
    name: 'ResetPasswordDone',
    component: ResetPasswordDone
  },
 /*  {
    path: '/payment',
    name: 'Payment',
    component: Payment,
    meta: { requiresAuth: true }
  },
   {
    path: '/payment-success',
    name: 'PaymentSuccess',
    component: PaymentSuccess,
    meta: { requiresAuth: true }
  },
  {
    path: '/payment-offer',
    name: 'PaymentOffer',
    component: PaymentOffer,
    meta: { requiresAuth: true }
  }, */
  {
    path: '/paddleCheckout',
    name: 'PaddleCheckout',
    component: PaddleCheckout,
    meta: { requiresAuth: false }
  },
  {
    path: '/cancel-plan',
    name: 'CancelPlan',
    component: CancelPlan,
    meta: { requiresAuth: true }
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout,
    meta: { requiresAuth: false }
  },
  {
    path: '/checkoutCompleted',
    name: 'CheckoutCompleted',
    component: CheckoutCompleted,
    meta: { requiresAuth: false }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (store.state.lang && store.state.lang !== i18n.locale) {
    i18n.locale = store.state.lang
    localeChanged()
  }
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = firebase.auth().currentUser
  if (requiresAuth && !isAuthenticated) {
    next({ path: '/login', query: { ...to.query, action: to.name } })
  } else if (isAuthenticated && to.name == 'Login') {
    next({ path: '/', query: to.query })
  } else next()
})

router.afterEach(async (to, from) => {
  if (router.app.$hj) {
    router.app.$hj('stateChange', to.path)
  }
  if (process.env.VUE_APP_FEATURE_STAGE == 'prod')
    gtag('event', 'WEB_PAGEVIEW', {
      pageName: to.name
    })
  trackEvent('WEB_PAGEVIEW', {
    pageName: to.name
  })
})

export default router
